/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetRecipeIngredientView } from '../model/getRecipeIngredientView';
import { HttpError } from '../model/httpError';
import { RecipeIngredientBulkInsertInner } from '../model/recipeIngredientBulkInsertInner';
import { RecipeIngredientBulkInsertView } from '../model/recipeIngredientBulkInsertView';
import { RecipeIngredientInsert } from '../model/recipeIngredientInsert';
import { RecipeIngredientUpdate } from '../model/recipeIngredientUpdate';
import { RecipeIngredientView } from '../model/recipeIngredientView';
import { SearchRecipeIngredientView } from '../model/searchRecipeIngredientView';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RecipeIngredientsService {

    protected basePath = 'https://develop-sysnet-api.hlcloud.com.au';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Creates multiple new RecipeIngredient records&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_recipeingredients&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_recipeingredients&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_recipeingredients_events&#x27; to receive events on this route.
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsBulkInsertPost(body?: Array<RecipeIngredientBulkInsertInner>, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RecipeIngredientBulkInsertView>>;
    public recipeIngredientsBulkInsertPost(body?: Array<RecipeIngredientBulkInsertInner>, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RecipeIngredientBulkInsertView>>>;
    public recipeIngredientsBulkInsertPost(body?: Array<RecipeIngredientBulkInsertInner>, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RecipeIngredientBulkInsertView>>>;
    public recipeIngredientsBulkInsertPost(body?: Array<RecipeIngredientBulkInsertInner>, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<RecipeIngredientBulkInsertView>>('post',`${this.basePath}/RecipeIngredients/bulkInsert`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a RecipeIngredient object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_recipeingredients&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_recipeingredients&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_recipeingredients_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public recipeIngredientsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public recipeIngredientsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public recipeIngredientsByExternalKeyIdDelete(id: string, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipeIngredientsByExternalKeyIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/RecipeIngredients/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a RecipeIngredient object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_recipeingredients
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates FKExternalKeys   - **RecipeStockIdFKObject:** stockId, externalKeys  - **IngredientStockIdFKObject:** stockId, externalKeys  - **IngredientFactorIdFKObject:** factorId, externalKeys               
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'body', reportProgress?: boolean): Observable<GetRecipeIngredientView>;
    public recipeIngredientsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetRecipeIngredientView>>;
    public recipeIngredientsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetRecipeIngredientView>>;
    public recipeIngredientsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipeIngredientsByExternalKeyIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetRecipeIngredientView>('get',`${this.basePath}/RecipeIngredients/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a RecipeIngredient object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_recipeingredients&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_recipeingredients&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_recipeingredients_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its user specific unique external key
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsByExternalKeyIdPut(id: string, body?: RecipeIngredientUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RecipeIngredientView>>;
    public recipeIngredientsByExternalKeyIdPut(id: string, body?: RecipeIngredientUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RecipeIngredientView>>>;
    public recipeIngredientsByExternalKeyIdPut(id: string, body?: RecipeIngredientUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RecipeIngredientView>>>;
    public recipeIngredientsByExternalKeyIdPut(id: string, body?: RecipeIngredientUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipeIngredientsByExternalKeyIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<RecipeIngredientView>>('put',`${this.basePath}/RecipeIngredients/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Search for RecipeIngredient objects&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_recipeingredients
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates SearchRecipeIngredientWithStock   - **Ingredient:** stockId, name, type, quantity, mappingWeightUom, mappingVolumeUom, mappingWeightQty, mappingVolumeQty  SearchStockAndFactorDetails   - **Stock:** stockId, name, inventoryCode, innersPerOuter, averageCost, lastCost  - **Factor:** divider  FKExternalKeys   - **RecipeStockIdFKObject:** stockId, externalKeys  - **IngredientStockIdFKObject:** stockId, externalKeys  - **IngredientFactorIdFKObject:** factorId, externalKeys               
     * @param group This parameter is used to group results.                         The fieldName can be any of the following: recipeStockId, ingredientStockId, ingredientFactorId.                         The sort could either have - to sort by descending and + to sort by ascending. See groupQuery schema for more info.                         For grouping using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param groupSummary This parameter is used to summarise grouped results by aggregating the groups.                 The fieldName can be any of the following: recipeIngredientId, recipeStockId, ingredientStockId, ingredientFactorId, factorQty, displayOrder.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param totalSummary This parameter is used to summarise all grouped results by aggregating all the groups sub groups.                 The fieldName can be any of the following: recipeIngredientId, recipeStockId, ingredientStockId, ingredientFactorId, factorQty, displayOrder.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param searchDistinct This parameter is used to get the distinct values for a field.                  Only the field specified will be returned in the results. This can be used with filtering functionality, sort and limit.                  However it cannot be used with group, groupSummary or totalSummary.
     * @param sort This parameter is used to change the sorting of results returned.                          The default sort is recipeIngredientId ascending.                          Use any fieldNames comma separated in the sort.                          Use + for ascending - for descending                          eg +updateDateTime.                         - recipeIngredientId would sort by updateDateTime ascending and then recipeIngredientId descending.  For sorting using a nested field use &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested levels eg +Stock.name                         For sorting using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param limit This limits the amount of results returned. This default limit Is set to 20. The maximum limit is 200.
     * @param offset This parameter is used to change the default offset from 0. Offset is the position in the dataset of a particular record. By specifying offset, you retrieve a subset of records starting with the offset value. Eg: If you have 100 records in your result set, and you want to retrieve records 50 to 80, you will need to use offset&#x3D;49 and limit &#x3D; 30.
     * @param search This does an &lt;b&gt;advanced&lt;/b&gt; search using a url encoded JSON object. &lt;br&gt;&lt;br&gt;  Most fields available in the return object can be searched using this methodology. &lt;br&gt;Example: search&#x3D;{ \&quot;status\&quot;: \&quot;active\&quot;} would search the status field for the value: &#x27;active&#x27;.&lt;br&gt;&lt;br&gt;  Searching is also possible using nested fields. Use the following syntax: &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested field.&lt;br&gt; Example: search&#x3D;{ \&quot;Stock.name\&quot;: \&quot;Best Beer\&quot; }&lt;br&gt;&lt;br&gt;  There are a couple of extra operators that can be used in the search. These are $or, $and, $not. &lt;br&gt; Example: search&#x3D;{ \&quot;$or\&quot;: [ { \&quot;status\&quot;: \&quot;bad\&quot; }, { \&quot;status\&quot;: \&quot;worse\&quot; } ] }. Searches for the statuses of &#x27;bad&#x27; or &#x27;worse&#x27;.&lt;br&gt; The $or, $and and $not operators can be nested.&lt;br&gt;&lt;br&gt;  If the name pair contains a fieldName it is possible for the value to be a sub-object containing any number of operators. The operators depend on the fieldType of the fieldName:&lt;br&gt;&lt;br&gt; &lt;b&gt;Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt;&lt;br&gt; &lt;b&gt;Number Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $gt, $gte, $lt, $lte, $between, $notBetween, $in, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;totalCount\&quot;: { \&quot;$gt\&quot;: 10 } } &lt;br&gt;&lt;br&gt; &lt;b&gt;String Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $in, $like, $iLike, $notLike, $notILike, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;failReason\&quot;: { \&quot;$in\&quot;: [\&quot;Out of bounds\&quot;, \&quot;Out of time\&quot;] } }&lt;br&gt;&lt;br&gt;  These operators equate to Sequelize operators. See &lt;a href&#x3D;\&quot;https://sequelize.org/docs/v7/querying/operators\&quot;&gt;Operators | Sequelize&lt;/a&gt;
     * @param recipeIngredientId The unique identifier of this record.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the recipeIngredientId field and returns all available results that match.   You can use &gt;10 to search for all recipeIngredientIds greater than 10. You can use [1,2,3] to search for recipeIngredientIds that match either 1, 2 or 3. You can use this parameter multiple times. eg recipeIngredientId&#x3D;&gt;5&amp; recipeIngredientId&#x3D;&lt;10 would search for all recipeIngredientIds between 5 and 10.
     * @param recipeStockId A reference to the primary key in the Stock Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the recipeStockId field and returns all available results that match.   You can use &gt;10 to search for all recipeStockIds greater than 10. You can use [1,2,3] to search for recipeStockIds that match either 1, 2 or 3. You can use this parameter multiple times. eg recipeStockId&#x3D;&gt;5&amp; recipeStockId&#x3D;&lt;10 would search for all recipeStockIds between 5 and 10.
     * @param ingredientStockId A reference to the primary key in the Stock Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the ingredientStockId field and returns all available results that match.   You can use &gt;10 to search for all ingredientStockIds greater than 10. You can use [1,2,3] to search for ingredientStockIds that match either 1, 2 or 3. You can use this parameter multiple times. eg ingredientStockId&#x3D;&gt;5&amp; ingredientStockId&#x3D;&lt;10 would search for all ingredientStockIds between 5 and 10.
     * @param ingredientFactorId A reference to the primary key in the Factors Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the ingredientFactorId field and returns all available results that match.   You can use &gt;10 to search for all ingredientFactorIds greater than 10. You can use [1,2,3] to search for ingredientFactorIds that match either 1, 2 or 3. You can use this parameter multiple times. eg ingredientFactorId&#x3D;&gt;5&amp; ingredientFactorId&#x3D;&lt;10 would search for all ingredientFactorIds between 5 and 10.
     * @param factorQty &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the factorQty field and returns all available results that match.   You can use &gt;10 to search for all factorQtys greater than 10. You can use [1,2,3] to search for factorQtys that match either 1, 2 or 3. You can use this parameter multiple times. eg factorQty&#x3D;&gt;5&amp; factorQty&#x3D;&lt;10 would search for all factorQtys between 5 and 10.
     * @param weightRequired &lt;br&gt;&lt;b&gt;boolean:&lt;/b&gt;
     * @param displayOrder &lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the displayOrder field and returns all available results that match.   You can use &gt;10 to search for all displayOrders greater than 10. You can use [1,2,3] to search for displayOrders that match either 1, 2 or 3. You can use this parameter multiple times. eg displayOrder&#x3D;&gt;5&amp; displayOrder&#x3D;&lt;10 would search for all displayOrders between 5 and 10.
     * @param createDateTime The date and time this record was created.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the createDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all createDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for createDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg createDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; createDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all createDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param updateDateTime The last date and time this record was updated.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the updateDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all updateDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for updateDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg updateDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; updateDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all updateDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param lastUpdateByUserId The userId of the last person to modify this record.&lt;br&gt;This parameter searches for the lastUpdateByUserId field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param externalKey The unique external key set by the current user accessing the API&lt;br&gt;This parameter searches for the externalKey field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param organisationId Allows an api user to filter results by 1 or more organisationIds. To use multiple organisationIds: organisationId&#x3D;[org1,org2]
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, recipeIngredientId?: number, recipeStockId?: number, ingredientStockId?: number, ingredientFactorId?: number, factorQty?: string, weightRequired?: string, displayOrder?: number, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, externalKey?: string, organisationId?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchRecipeIngredientView>;
    public recipeIngredientsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, recipeIngredientId?: number, recipeStockId?: number, ingredientStockId?: number, ingredientFactorId?: number, factorQty?: string, weightRequired?: string, displayOrder?: number, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, externalKey?: string, organisationId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchRecipeIngredientView>>;
    public recipeIngredientsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, recipeIngredientId?: number, recipeStockId?: number, ingredientStockId?: number, ingredientFactorId?: number, factorQty?: string, weightRequired?: string, displayOrder?: number, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, externalKey?: string, organisationId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchRecipeIngredientView>>;
    public recipeIngredientsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, recipeIngredientId?: number, recipeStockId?: number, ingredientStockId?: number, ingredientFactorId?: number, factorQty?: string, weightRequired?: string, displayOrder?: number, createDateTime?: string, updateDateTime?: string, lastUpdateByUserId?: string, externalKey?: string, organisationId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('group', <any>group);
        }
        if (groupSummary !== undefined && groupSummary !== null) {
            queryParameters = queryParameters.set('groupSummary', <any>groupSummary);
        }
        if (totalSummary !== undefined && totalSummary !== null) {
            queryParameters = queryParameters.set('totalSummary', <any>totalSummary);
        }
        if (searchDistinct !== undefined && searchDistinct !== null) {
            queryParameters = queryParameters.set('searchDistinct', <any>searchDistinct);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (recipeIngredientId !== undefined && recipeIngredientId !== null) {
            queryParameters = queryParameters.set('recipeIngredientId', <any>recipeIngredientId);
        }
        if (recipeStockId !== undefined && recipeStockId !== null) {
            queryParameters = queryParameters.set('recipeStockId', <any>recipeStockId);
        }
        if (ingredientStockId !== undefined && ingredientStockId !== null) {
            queryParameters = queryParameters.set('ingredientStockId', <any>ingredientStockId);
        }
        if (ingredientFactorId !== undefined && ingredientFactorId !== null) {
            queryParameters = queryParameters.set('ingredientFactorId', <any>ingredientFactorId);
        }
        if (factorQty !== undefined && factorQty !== null) {
            queryParameters = queryParameters.set('factorQty', <any>factorQty);
        }
        if (weightRequired !== undefined && weightRequired !== null) {
            queryParameters = queryParameters.set('weightRequired', <any>weightRequired);
        }
        if (displayOrder !== undefined && displayOrder !== null) {
            queryParameters = queryParameters.set('displayOrder', <any>displayOrder);
        }
        if (createDateTime !== undefined && createDateTime !== null) {
            queryParameters = queryParameters.set('createDateTime', <any>createDateTime);
        }
        if (updateDateTime !== undefined && updateDateTime !== null) {
            queryParameters = queryParameters.set('updateDateTime', <any>updateDateTime);
        }
        if (lastUpdateByUserId !== undefined && lastUpdateByUserId !== null) {
            queryParameters = queryParameters.set('lastUpdateByUserId', <any>lastUpdateByUserId);
        }
        if (externalKey !== undefined && externalKey !== null) {
            queryParameters = queryParameters.set('externalKey', <any>externalKey);
        }
        if (organisationId !== undefined && organisationId !== null) {
            queryParameters = queryParameters.set('organisationId', <any>organisationId);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SearchRecipeIngredientView>('get',`${this.basePath}/RecipeIngredients/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a RecipeIngredient object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_recipeingredients&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_recipeingredients&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_recipeingredients_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsIdDelete(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public recipeIngredientsIdDelete(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public recipeIngredientsIdDelete(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public recipeIngredientsIdDelete(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipeIngredientsIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/RecipeIngredients/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a RecipeIngredient object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_recipeingredients
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates FKExternalKeys   - **RecipeStockIdFKObject:** stockId, externalKeys  - **IngredientStockIdFKObject:** stockId, externalKeys  - **IngredientFactorIdFKObject:** factorId, externalKeys               
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsIdGet(id: number, ridChain?: string, view?: string, observe?: 'body', reportProgress?: boolean): Observable<GetRecipeIngredientView>;
    public recipeIngredientsIdGet(id: number, ridChain?: string, view?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetRecipeIngredientView>>;
    public recipeIngredientsIdGet(id: number, ridChain?: string, view?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetRecipeIngredientView>>;
    public recipeIngredientsIdGet(id: number, ridChain?: string, view?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipeIngredientsIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetRecipeIngredientView>('get',`${this.basePath}/RecipeIngredients/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a RecipeIngredient object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_recipeingredients&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_recipeingredients&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_recipeingredients_events&#x27; to receive events on this route.
     * @param id Used to identify a specific record by its unique ID
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsIdPut(id: number, body?: RecipeIngredientUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RecipeIngredientView>>;
    public recipeIngredientsIdPut(id: number, body?: RecipeIngredientUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RecipeIngredientView>>>;
    public recipeIngredientsIdPut(id: number, body?: RecipeIngredientUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RecipeIngredientView>>>;
    public recipeIngredientsIdPut(id: number, body?: RecipeIngredientUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling recipeIngredientsIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<RecipeIngredientView>>('put',`${this.basePath}/RecipeIngredients/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Creates a new RecipeIngredient&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_recipeingredients&lt;br&gt;&lt;br&gt;This route generates events on the topic name: &#x27;sc_organisation_${organisationId}_recipeingredients&#x27; where organisation Id is the H&amp;L cloud assigned ID for your organisation.      &lt;br&gt;You can get a list of organisations that you have access to through the /organisations route.      &lt;br&gt;&lt;br&gt;You will need to be assigned the following data access &#x27;sc_receive_recipeingredients_events&#x27; to receive events on this route.
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipeIngredientsPost(body?: RecipeIngredientInsert, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<RecipeIngredientView>;
    public recipeIngredientsPost(body?: RecipeIngredientInsert, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RecipeIngredientView>>;
    public recipeIngredientsPost(body?: RecipeIngredientInsert, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RecipeIngredientView>>;
    public recipeIngredientsPost(body?: RecipeIngredientInsert, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RecipeIngredientView>('post',`${this.basePath}/RecipeIngredients/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
